import {createWebHistory, createRouter, RouteLocationNormalized} from "vue-router";
import {keycloakStore} from "../store/LoginStates";
import Administration from "../components/Administration.vue";
import PageNotFound from "../components/PageNotFound.vue";
import folder from "../assets/icons/folder.svg"
import shopIcon from "../assets/icons/shop.svg"
import groups from "../assets/icons/groups.svg"
import bannerIcon from "../assets/icons/banner.svg"


declare module 'vue-router' {
    interface RouteMeta {
        requiresAuth: boolean,
        icon?: string
    }
}

export const routes = [
    {
        path: "/",
        name: "Accueil",
        component: () => import('../components/Home.vue'),
        meta: {
            requiresAuth: false
        }
    },
    {
        path: "/vote",
        name: "Vote",
        component: () => import('../components/Vote.vue'),
        meta: {
            requiresAuth: false
        }
    },
    {
        path: "/shop",
        name: "Boutique",
        component: () => import('../components/Shop.vue'),
        meta: {
            requiresAuth: false
        }
    },
    {
        path: "/wiki/:category?/:document?",
        name: "Wiki",
        component: () => import('../components/Wiki.vue'),
        meta: {
            requiresAuth: false
        }
    },
    {
        path: "/leaderboard",
        name: "Classement",
        component: () => import('../components/LeaderBoard.vue'),
        meta: {
            requiresAuth: false
        }
    },
    {
        path: "/admin",
        name: "Administration",
        component: Administration,
        redirect: (to: RouteLocationNormalized) => ({
            path: '/admin/wiki-editor',
            query: to.query,
            hash: to.hash,
        }),
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: "wiki-editor",
                name: "Wiki Editor",
                component: () => import('../components/configurators/WikiConfigurator.vue'),
                meta: {
                    requiresAuth: true,
                    icon: folder
                }
            },
            {
                path: "shop",
                name: "Shop",
                component: () => import('../components/configurators/ShopEditor.vue'),
                meta: {
                    requiresAuth: true,
                    icon: shopIcon
                }
            },
            {
                path: "users",
                name: "Utilisateur",
                component: () => import('../components/configurators/UserConfigurator.vue'),
                meta: {
                    requiresAuth: true,
                    icon: groups
                }
            },
            {
                path: "banner",
                name: "Bandeau",
                component: () => import('../components/configurators/BannerEditor.vue'),
                meta: {
                    requiresAuth: true,
                    icon: bannerIcon
                }
            },
        ]
    },
    {
        path: "/:pathMatch(.*)*",
        component: PageNotFound,
        meta: {
            requiresAuth: false
        }
    },
];

export const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach(async (to) => {
    if (to.meta.requiresAuth) {
        const authenticated = await keycloakStore.requireAuth(to.path);
        if (!authenticated) {
            return false;
        }
    }
})

export default router;
